import { hasSingleRole } from 'services/Authorization';
import { Roles } from 'UI/constants/roles';

export const statusAll = 'All';

export const COACH_MAP = {
  gpac: 'gpac',
  regional: 'regional'
};

export const DAYS_MAP = {
  mo: 'Mon',
  tu: 'Tue',
  we: 'Wed',
  th: 'Thu',
  fr: 'Fri',
  sa: 'Sat',
  su: 'Sun'
};

export const MAIN_COLUMN_ID = 'team';

const DEFAULT_OPTIONS = {
  display: true
};

export const COLUMNS_DEFINITIONS = [
  {
    id: 'team',
    label: 'Team',
    category: 'team',
    shouldAddWeeklyColumns: false,
    options: DEFAULT_OPTIONS
  },
  {
    id: 'dials',
    label: 'Calls',
    category: 'dials',
    shouldAddWeeklyColumns: true,
    options: DEFAULT_OPTIONS
  },
  {
    id: 'in_mails',
    label: 'InMails',
    category: 'inMails',
    shouldAddWeeklyColumns: true,
    options: DEFAULT_OPTIONS
  },
  {
    id: 'new_live_posts',
    label: 'New Live Posts',
    category: 'newLivePosts',
    shouldAddWeeklyColumns: true,
    options: DEFAULT_OPTIONS
  },
  {
    id: 'live_posts',
    label: 'Live Posts',
    category: 'livePosts',
    shouldAddWeeklyColumns: false,
    options: DEFAULT_OPTIONS
  },
  {
    id: 'bulks',
    label: 'Bulks',
    category: 'bulks',
    shouldAddWeeklyColumns: true,
    options: DEFAULT_OPTIONS,
    subLabelId: 'reached',
    subLabel: 'Reached'
  },
  {
    id: 'draw_balance',
    label: 'Draw Balance',
    category: 'drawBalance',
    shouldAddWeeklyColumns: false,
    options: {
      display: hasSingleRole(Roles.Recruiter) ? 'excluded' : true
    }
  }
];

const getColumnsFromDefinitions = () => {
  return COLUMNS_DEFINITIONS.flatMap(
    ({ shouldAddWeeklyColumns, id, label, subLabelId, ...rest }) => {
      if (!shouldAddWeeklyColumns) {
        return [{ id, label, subLabelId, ...rest }];
      }

      const dayColumns = Object.keys(DAYS_MAP).map(day => ({
        ...rest,
        id: `${id}_${day}`,
        label: `${label}\n${DAYS_MAP[day]}`,
        isDayColumn: true,
        subLabelId: subLabelId ? `${subLabelId}_${day}` : null
      }));

      const totalColumn = {
        ...rest,
        id: `${id}_total`,
        label: `${label}\nTotal`,
        subLabelId: subLabelId ? `${subLabelId}_total` : null
      };

      return [...dayColumns, totalColumn];
    }
  );
};

export const columns = getColumnsFromDefinitions().filter(
  column => column.options.display === true
);
